<template>
    <LoadingCard :is-show="isLoading" />
    <q-layout view="hHh lpR fFf">
        <EvalIntro v-if="showIntro" @on-start="gotoEvalTest" :is-loading="isLoading" @update:isLoading="(value) => (isLoading = value)" />
        <div v-if="!showIntro">
            <q-header class="bg-white pd_left_40 pd_right_40">
                <q-toolbar>
                    <div class="display_flex color_gray_900">
                        <q-icon name="img:/assets/images/icon/ico_back.svg" @click="onBack" style="width: 2.4vw; height: 2.4vw; cursor: pointer" />
                        <span class="q-px-sm b1 medium line_height_45 header_lesson">진단평가</span>
                    </div>
                    <p class="home__img">
                        <q-icon name="img:/assets/images/icon/ico_home.svg" @click="onHome" style="width: 2.4vw; height: 2.4vw; cursor: pointer" />
                    </p>
                </q-toolbar>
            </q-header>
            <div class="page">
                <div class="color_gray_900 page__content">
                    <div class="page__inner">
                        <div class="page__inner__display_flex">
                            <!-- <div style="margin: 10px; background-color: #127"> -->
                            <div class="page__txt">
                                <p class="b2 medium color_gray_600 line_height_42">KReaD 기반의 국어 지식맵과 수능유형 트레이닝</p>
                                <h2 class="mg_top_8 h1 bold line_height_66">
                                    KReaD로 독해 실력을
                                    <span class="display_block bold text-primary">수능 1등급까지 한번에 UP!</span>
                                </h2>
                                <p class="mg_top_32 b3 line_height_42 summary">
                                    수능국어트레이닝은 KReaD 기반의 단계별 지문과 국어 지식맵을 바탕으로 학습자 수준에 맞는 드릴 학습을 제공합니다. <br />
                                    다양한 문학 작품과 전문성이 높은 비문학 글을 경험하여<br />낯선 지문에 대한 적응력을 높여 주고, 수능 베이직&심화 유형을<br />완벽히 트레이닝할 수 있습니다.
                                </p>
                                <q-btn flat class="transparent" @click="popInfo = !popInfo">
                                    <img src="@/assets/images/symbols/info_kread_green.png" alt="logo" />
                                </q-btn>
                                <!-- TODO: 학년선택 -->
                                <div class="select-box" v-if="haveTested">
                                    <CusSelect :li-list="optionsDate" v-model:current="gDate" @onReturn="onSelected" whichType="eval" :is-disable="isSelectGradeDisable" />
                                </div>
                            </div>
                            <p class="page__img">
                                <img src="@/assets/images/icon/img_intro_02_green.png" alt="diagnostic_login_left" />
                            </p>
                        </div>
                        <div class="page__content__btn_wrapper">
                            <CusButton :type="200" :label="`진단평가 시작하기`" @onReturn="onOpenInstro" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </q-layout>

    <q-dialog v-model="popInfo" class="modal">
        <q-card class="modal__wrap">
            <q-card-section class="row items-center q-pb-none">
                <q-space />
                <q-icon name="close" align="right" class="modal--close" @click="popInfo = false" />
            </q-card-section>

            <q-card-section>
                <q-space />
                <div class="modal__content">
                    <h2 class="modal__title">
                        <span class="text-primary">국내 최초 한국어 독해 지수 </span>
                        <span class="kread__logo">
                            <img src="@/assets/images/symbols/logo_kread_text_green.png" />
                        </span>
                    </h2>
                    <p class="tx50 modal__txt">
                        크리드(KReaD)는 글의 난이도와 학습자의 읽기 능력 수준을<br />
                        <span class="text-primary">AI로 측정한 ‘한국어 독해 지수’입니다. </span>
                        크리드 지수가 높을수록 글의 난이도가 높고, 학습자의 읽기 능력<br />
                        수준이 뛰어남을 나타냅니다. (특허 제 10-2201709호)
                    </p>
                    <div class="modal__img">
                        <p class="tx50">내 읽기 수준에 맞는 글을 읽어야 한다는<br />생각으로 만든 <span class="text-bold">‘한국어 독해 지수’ </span></p>
                        <p class="grade__img">
                            <img src="/assets/images/symbols/eval_info_grade.png" />
                        </p>
                    </div>
                </div>
            </q-card-section>
        </q-card>
    </q-dialog>

    <!--     
    <q-dialog v-model="popInfo" class="modal">
        <q-card class="modal__wrap">
            <q-card-section class="row items-center q-pb-none">
                <q-space />
                <q-icon name="close" align="right" class="modal--close" @click="popInfo = false" />
            </q-card-section>

            <q-card-section>
                <q-space />
                <div class="modal__content">
                    <h2 class="modal__title">
                        <span class="kread__logo">
                            <img src="/assets/images/symbols/logo_kread_text.png" style="display: inline" />
                        </span>
                        <span class="text-primary">란?</span>
                    </h2>
                    <p class="tx50 modal__txt">
                        크리드(KReaD)는 글의 난이도와 학습자의 읽기 능력 수준을<br />
                        <span class="text-primary">AI로 측정한 ‘한국어 독해 지수’입니다. </span>
                        크리드는 한국어 난이도 지수를 산출하여 글의 어렵고 쉬운 정도와<br />
                        학습자의 읽기 능력 수준을 파악하고자 개발되었습니다.
                    </p>
                    <div class="modal__img">
                        <p class="tx50">내 읽기 수준에 맞는 글을 읽어야 한다는<br />생각으로 만든 <span class="text-bold">'한국어 독해 지수' </span></p>
                        <p class="grade__img">
                            <img src="/assets/images/symbols/eval_info_grade.png" />
                        </p>
                    </div>
                </div>
            </q-card-section>
        </q-card>
    </q-dialog> -->
</template>

<script setup>
import { defineEmits, ref, onMounted, onUnmounted, watch, computed, toRaw } from 'vue';
import { getUserInfo } from '@/api/modules/mypage.js';
import { apiGetEvalList, apiGetEvalReport4Member } from '@/api/modules/eval_api.js';
import { apiLogin4Member } from '@/api/modules/eval_api.js';
import CqBtn from '@/components/quasar/cqBtn.vue';
import CusButton from '@/components/widget/CusButton.vue';
import EvalIntro from '@/views/eval_login/EvalIntro.vue';
import { DialogStore } from '@/store/modules/dialog';
import { GlobalStore } from '@/store';
import { useRouter, useRoute } from 'vue-router';

import Comm from '@/components/common.js';
import { monitoringLog } from '@/api/modules/monitoring';
import { optionsGrade } from '@/helpers/constants';
import { label } from 'quasar/lang/ko-KR';
import CusSelect from '@/components/widget/CusSelectForDiagnostic.vue';
import LoadingCard from '@/components/quasar/loadingCard.vue';

const route = useRoute();

const dStore = DialogStore();
const gStore = GlobalStore();
const router = useRouter();
const isLoading = ref(null);

const popInfo = ref(false);
const showIntro = ref(false);
const haveTested = ref(false);
const isSelectGradeDisable = ref(false);
let back = 'mypage';

const onOpenInstro = (data) => {
    showIntro.value = true;
    gStore.setIsMemberEval(true); // 회원 진단평가 시작.
};

const onSelected = (index) => {
    gDate.value = optionsDate[index];
    //console.log('gDate.value', gDate.value);
    gStore.setSelectedKread(gDate.value.value);
    //console.log('gStore.selected_kread', gStore.selected_kread);
};

const optionsDate = optionsGrade.map((option) => ({
    value: option.value,
    label: option.label,
}));
//'학년' 옵션을 추가
optionsDate.unshift({ value: '', label: '학년' });

const gDate = ref(optionsDate[0]);

if (gStore.selected_kread) {
    gDate.value = optionsDate.find((item) => item.value === gStore.selected_kread);
}

const gotoEvalTest = async () => {
    // let isFirst = false;
    // const resList = await apiGetEvalList();
    // if (resList && resList.status === 200) isFirst = resList.data.data.length < 1;

    const res = await getUserInfo(gStore.token);
    if (res) {
        // console.log('--info-res-', res);
        if (res.status === 200) {
            const userData = res.data.data;
            // console.log('======================useData', userData.grade);
            // console.log('======================gStore.selected_kread', gStore.selected_kread);
            const baseKread = gStore.selected_kread ? gStore.selected_kread : userData.grade;
            // console.log('======================baseKread', baseKread);

            gStore.setEvalData({
                nick: userData.studentName,
                real_grade: userData.grade,
                academy_code: userData.academyCode,
                first_kread: Comm.getExamGrade(baseKread),
                start_kread: Comm.getFirstPointGrade(baseKread),
                // first_kread: userData.grade === '08' ? 'M2' : userData.grade === '09' ? 'M3' : 'M1',
                // start_kread: userData.grade === '08' ? 1400 : userData.grade === '09' ? 1500 : 1300,
                is_eval: true, // 진단 or 수능
                is_study: false, // 풀이인지
            });

            gStore.setIsMemberEval(true); // 분석리포트를 위해.
            // console.log('-gotoEvalTest-evalData--', gStore.evalData);
            // console.log('-gotoEvalTest-userData.grade === --', userData.grade === '09');

            /////// GOTO_EVAL_TEST ///////
            // console.log('gStore.selected_kread : ', gStore.selected_kread);
            // console.log('baseKread : ', baseKread);
            const resEval = await apiLogin4Member(gStore.selected_kread && { grade: baseKread });
            // console.log('--getEvalLoginForMember--accessToken', resEval.data.data.accessToken);
            if (resEval)
                if (resEval.status === 200) {
                    gStore.setTokenForEval(resEval.data.data.accessToken);
                    gStore.setReTokenForEval(resEval.data.data.refreshToken);
                    gStore.setVersionForEval(resEval.data.data.version);
                    router.push('/eval-test');
                }
        }
    }
};

const onBack = () => {
    router.push('/' + back);
    // if (showIntro.value) router.go(router.currentRoute);
    // else router.push('/mypage');
};

const onHome = () => {
    dStore.openConfirmDialog({
        message: '홈으로 이동하시겠습니까?',
        cancel: '닫기',
        ok: '확인',
        callback: (val) => {
            val && router.push('/learninghome');
        },
    });
};

/**
 * 진단평가 경험 체크
 * @returns void
 */
const checkHasEvalTest = async () => {
    //console.log('checkHasEvalTest');
    const getEvalRes = await apiGetEvalList();
    // console.log('진단평가 받아오는값 ===', getEvalRes.data.data);

    if (getEvalRes.data.data.length > 0) {
        const length = getEvalRes.data.data.length;
        //console.log(getEvalRes.data.data[0]['endDate']);
        //console.log(`length :: ${length}    `);
        //최초 진단 평가 진행중인지 체크
        if (length === 1 && !getEvalRes.data.data[0]['endDate']) {
            //console.log('최초 진단편가 진행중.');
            haveTested.value = false;
            return;
        }
        //console.log(getEvalRes.data.data[0]['endDate']);
        //(최초가 아닌) 진단평가가 진행중인지 체크
        if (length > 1 && !getEvalRes.data.data[0]['endDate']) {
            haveTested.value = true;
            isSelectGradeDisable.value = true;
            // console.log(getEvalRes.data.data[0]);
            if (getEvalRes.data.data[0].grade) {
                //console.log('선택한 학년 데이터가 있음');
                gStore.setSelectedKread(getEvalRes.data.data[0].grade); //선택한 학년 데이터가 있을 경우
                gDate.value = optionsDate.find((item) => item.value === gStore.selected_kread);
            }
            return;
        }
        haveTested.value = true;
    } else {
        haveTested.value = false;
    }

    // haveTested.value = getEvalRes.data.data.length > 0 ? true : false;
    //console.log('haveTest ===', haveTested.value);
};

onMounted(() => {
    // console.log('onMounted');

    if (route.query.back) {
        back = route.query.back;
    }

    // console.log(showIntro.value);

    checkHasEvalTest();
    let data = {
        menuName: route.path.split('/').join(''),
    };

    isLoading.value = false;

    monitoringLog(data, (res) => {
        console.log('eval_login_mem monitoringLog API response ===', res);
    });
});
</script>

<style scoped lang="scss">
///////////commoncode///////////
html[data-useragent*='tablet'] {
    .tablet-summary {
        font-size: 1.18vw;
    }
}
p {
    margin-bottom: 0;
    line-height: inherit;
}

img {
    width: 100%;
}

.modal {
    .title {
        color: #222222;
        font-size: 2.1vmin;
        font-weight: 700;
        margin: 1.75vmin 0vmin 0.5vmin;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    &__wrap {
        width: 50vw;
        min-width: 500px;
        max-width: 1000px;
        border-radius: 2.5vmin;
    }

    &__content {
        padding: 0vmin 3.5vmin 2vmin;
    }

    &__checkbox ::v-deep {
        font-size: 1.6vmin;
    }

    .q-option-group ::v-deep {
        .q-checkbox__bg {
            border-radius: 50% !important;
        }
    }

    .q-checkbox ::v-deep {
        .q-checkbox__bg {
            border-radius: 50% !important;
        }
    }

    .btn {
        border-radius: 1vmin;
        margin-bottom: 2vmin;
    }

    .close {
        margin: 1.5vmin;
    }

    .q-option-group {
        ::v-deep > div {
            width: 23%;
        }
    }

    &--close {
        position: absolute;
        top: 2.67vmin;
        right: 2.67vmin;
        font-size: 2.4vw;
        cursor: pointer;
    }

    &__txt {
        margin-top: 0.92vmin;
        font-size: 1.3vw;
        line-height: 2.1vw;

        .text-primary {
            display: block;
            font-weight: 500;
        }
    }

    &__img {
        margin-top: 2.67vmin;
        padding: 3.33vmin 6.67vmin 2.83vmin;
        border-radius: 2.67vmin;
        background: $color_gray_200;

        .tx50 {
            font-size: 1.3vw;
            text-align: center;
            line-height: 2.1vw;
        }

        .grade__img {
            margin-top: 2vmin;
        }
    }

    h2 {
        font-size: 1.8vw;
        text-align: center;
        line-height: 2.6vw;

        .text-primary {
            font-weight: 700;
        }
    }

    .q-card {
        &__section {
            padding: 6.07vmin 3vmin 3vmin;

            &.items-center {
                padding: 0;
                z-index: 5;
            }
        }
    }

    .kread__logo {
        display: inline-block;
        width: 14%;
        max-width: 136px;

        img {
            vertical-align: bottom;
        }
    }
}

// button
button:disabled,
button[disabled] {
    // border: 1px solid #999999;
    background-color: #cccccc;
    color: #666666;
}

button {
    background-color: #00a2e0;
    color: #fff;
}

::v-deep {
    .q-toolbar {
        justify-content: space-between;
        align-items: center;
        min-height: inherit;
        margin: 1.75vmin 0;
        padding: 0;

        .display_flex {
            display: flex;
        }
        .q-icon {
            width: 2.4vw;
            height: 2.4vw;
            font-size: 1.4vw; //28px
            font-weight: 700;
        }
        .home__img {
            .q-icon {
                display: inline-block;
                width: 2.1vw;
                height: 2.1vw;
                padding: 0.29vmin 0.37vmin;
                box-sizing: border-box;
            }
        }
    }
    .page {
        &__txt {
            flex: 1;
            button {
                width: 27%;
                max-width: 176px;
                margin-top: 1.25vmin;
            }
            .q-btn {
                margin-top: 0.7vw;
                padding: 0;
            }
        }

        &__btn {
            width: 100%;
            max-width: 1464px;
            margin: 6.75vmin auto 0;
            padding: 2.75vmin 2.83vmin;
            @include border-radius(1.33vmin);
            font-size: 1.2vw;
            font-weight: 700;
            line-height: 1.6vw;
        }
    }
    .q-btn__content {
        .block {
            font-weight: 700;
        }
    }
    .q-btn--actionable.q-btn--standard:before {
        box-shadow: inherit;
    }
    .selectbox {
        width: 100%;
        height: 3.8vw;
        will-change: transform;
    }
}

.page {
    position: relative;
    height: 100vh;
    min-height: 747px;
    padding-top: calc(2.4vw + (1.75vmin * 2));

    &__content {
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;
        @include transform(translateY(-50%));
        .select-box {
            width: 100%;
            margin-top: 1.4vw;
            &__wrapper {
                width: 100%;
            }
        }
        &__btn_wrapper {
            margin-top: 4.2vw;
        }
    }

    &__inner {
        width: 80%;
        max-width: 1600px;
        margin: 0 auto;
        &__display_flex {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
        }
    }
    &__txt {
        font-size: 1.25vw;
        flex: 1;
        max-width: 690px;
    }
    &__img {
        flex: 1;
        max-width: 784px;
    }
    &__desktop__space {
        @include pc_wide {
            margin-top: 20px;
        }
    }
}
.start {
    width: 11%;
}

.summary {
    word-break: keep-all;
    @include pc_wide {
        font-size: 25px;
    }
}
</style>
